var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0H18C8.05887 0 0 8.05887 0 18V72C0 81.9411 8.05887 90 18 90H72C81.9411 90 90 81.9411 90 72V18C90 8.05887 81.9411 0 72 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5983 50.719C21.5983 52.9631 22.1083 54.6827 22.7778 55.7242C23.6537 57.0879 24.9578 57.6648 26.2891 57.6648C28.0097 57.6648 29.5785 57.2565 32.6071 53.2216C35.0323 49.9922 37.8896 45.4553 39.8127 42.6081L43.0709 37.7902C45.3326 34.4447 47.9486 30.7245 50.9538 28.2032C53.4024 26.1427 56.0495 25 58.7083 25C63.1772 25 67.432 27.4914 70.6864 32.1706C74.2522 37.2919 75.9806 43.7395 75.9806 50.3968C75.9806 54.353 75.1709 57.2602 73.7928 59.5605C72.4615 61.7821 69.8689 64 65.5012 64V57.6648C69.2383 57.6648 70.1725 54.3568 70.1725 50.5729C70.1725 45.1781 68.8646 39.1914 65.9878 34.913C63.948 31.8784 61.3009 30.0239 58.3891 30.0239C55.2437 30.0239 52.7095 32.313 49.86 36.389C48.3457 38.5545 46.7924 41.1957 45.0485 44.1741L43.1254 47.4522C39.2677 54.0421 38.2906 55.5444 36.3598 58.0208C32.9808 62.3553 30.0924 64 26.2891 64C21.7813 64 18.9279 62.1193 17.1644 59.287C15.7202 56.9755 15.0117 53.9447 15.0117 50.4942L21.5983 50.719Z",
    fill: "#0081FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2046 32.6164C23.2254 28.1357 27.5814 25 32.5798 25C35.4721 25 38.3489 25.8242 41.3541 28.1882C44.6396 30.7695 48.1431 35.0254 52.5147 42.0349L54.0796 44.5487C57.8634 50.6179 60.0161 53.7386 61.2735 55.211C62.8929 57.1029 64.0296 57.6648 65.5011 57.6648C69.2382 57.6648 70.1724 54.3568 70.1724 50.5729L75.9805 50.3968C75.9805 54.353 75.1708 57.2602 73.7927 59.5605C72.4614 61.7821 69.8688 64 65.5011 64C62.7878 64 60.3821 63.4305 57.7233 61.0179C55.6796 59.1634 53.2894 55.8703 51.452 52.9069L45.9865 44.1104C43.2421 39.6971 40.7235 36.4078 39.2676 34.9167C37.7027 33.3133 35.6862 31.3764 32.4747 31.3764C29.8704 31.3764 27.6632 33.1334 25.8141 35.8233L20.2046 32.6164Z",
    fill: "url(#paint0_linear_868_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4748 31.3764C29.8705 31.3764 27.6633 33.1334 25.8142 35.8233C23.1983 39.6222 21.5983 45.283 21.5983 50.719C21.5983 52.9631 22.1083 54.6827 22.7778 55.7242L17.1644 59.287C15.7202 56.9755 15.0117 53.9447 15.0117 50.4942C15.0117 44.2153 16.8024 37.6703 20.2047 32.6164C23.2255 28.1357 27.5815 25 32.5799 25L32.4748 31.3764Z",
    fill: "url(#paint1_linear_868_92)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_868_92",
    x1: 27.9473,
    y1: 48.8908,
    x2: 69.9187,
    y2: 51.0948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_868_92",
    x1: 24.5529,
    y1: 53.3827,
    x2: 24.5529,
    y2: 38.4758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob7);
export default __webpack_public_path__ + "static/media/blob7.ea514b27b927aa6685f8e5bcb53e8a6f.svg";
export { ForwardRef as ReactComponent };